import * as actionTypes from "../actionTypes";
import createReducer from "../lib/createReducer";
import findIndex from "lodash.findindex";

const defaultState = {};

function CRITERION_ADD(state, action) {
	const {
		allJoinpathIds,
		criterionId,
		extraData,
		hidden,
		highlight,
		inputType,
		maximum,
		messages,
		multiples,
		name,
		selectedJoinpathId,
		supportsAnd,
		supportsUpload,
		value,
	} = action;

	return {
		...state,
		[criterionId]: {
			__id: criterionId,
			allJoinpathIds,
			hasValidationError: false,
			validating: false,
			extraData,
			hidden: !!hidden,
			highlight: highlight || [],
			messages: messages || [],
			name,
			selectedJoinpathId,
			supportsAnd: !!supportsAnd,
			supportsUpload: !!supportsUpload,
			maximum,
			multiples,
			type: inputType,
			value,
		},
	};
}

function CRITERION_ADD_MULTIPLE(state, action) {
	const { criteria } = action;
	if (!criteria.length) {
		return state;
	}

	let nextState = state;
	criteria.forEach(c => {
		nextState = CRITERION_ADD(nextState, c);
	});

	return nextState;
}

function CRITERION_SET_VALUE(state, action) {
	const { criterionId, hasValidationError, validating, value } = action;
	if (!state[criterionId]) {
		console.warn(`criterion with id "${criterionId}" not found in state`);
		return state;
	}

	return {
		...state,
		[criterionId]: {
			...state[criterionId],
			hasValidationError: !!hasValidationError,
			validating: !!validating,
			value,
		},
	};
}

function CRITERION_SET_VALUE_MULTIPLE(state, action) {
	const { criteria } = action;
	if (!criteria.length) {
		return state;
	}

	let nextState = state;
	criteria.forEach(c => {
		nextState = CRITERION_SET_VALUE(nextState, c);
	});

	return nextState;
}

function CRITERION_SET_JOINPATH(state, action) {
	const { criterionId, selectedJoinpathId } = action;
	if (!state[criterionId]) {
		console.warn(`criterion with id "${criterionId}" not found in state`);
		return state;
	}

	const index = findIndex(state[criterionId].allJoinpathIds, id => id === selectedJoinpathId);
	if (index === -1) {
		throw new Error(
			`joinpath id "${selectedJoinpathId}" not valid for criterion id "${criterionId}" name "${
				state[criterionId].name
			}"`,
		);
	}

	return {
		...state,
		[criterionId]: {
			...state[criterionId],
			selectedJoinpathId,
		},
	};
}

function CRITERION_REMOVE_MULTIPLE(state, action) {
	const { criterionIds } = action;
	const nextState = { ...state };
	criterionIds.forEach(id => {
		delete nextState[id];
	});
	return nextState;
}

const handlers = {};
handlers[actionTypes.CRITERION_ADD] = CRITERION_ADD;
handlers[actionTypes.CRITERION_ADD_MULTIPLE_LAYOUT_TAB] = CRITERION_ADD_MULTIPLE;
handlers[actionTypes.CRITERION_ADD_MULTIPLE] = CRITERION_ADD_MULTIPLE;
handlers[actionTypes.CRITERION_REMOVE_MULTIPLE] = CRITERION_REMOVE_MULTIPLE;
handlers[actionTypes.CRITERION_SET_VALUE] = CRITERION_SET_VALUE;
handlers[actionTypes.CRITERION_SET_VALUE_MULTIPLE] = CRITERION_SET_VALUE_MULTIPLE;
handlers[actionTypes.CRITERION_SET_JOINPATH] = CRITERION_SET_JOINPATH;
export default createReducer(defaultState, handlers);
